export const LOGIN = {
    REQUEST: "LOGIN_REQUEST",
    SUCCESS: "LOGIN_SUCCESS",
    UPDATE: "LOGIN_UPDATE",
  };
  